@if (showStatistic() && statistic) {
  <div class="py-4" style="padding-left: 15px">
    <div class="pb-4">
      <h4>{{ 'DATAS.title' | translate: {count: 1} }}</h4>
      <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection">
        <mat-chip-option
          (click)="selectPriceData()"
          [selected]="isPriceDataSelected()"
          [disabled]="isPriceDataSelected()">
          {{ 'DATAS.price_data' | translate }}
        </mat-chip-option>
        @for (data of dataList; track data.id) {
          <mat-chip-option
            [value]="data"
            (click)="toggleSectionID(data, 'datasource')"
            [selected]="isSectionSelected(data)"
            [disabled]="isSectionSelected(data)">
            {{  data.translations[currentLanguage].title}}
          </mat-chip-option>
        }
        @for (allocation of allocationDataList; track allocation.id) {
          <mat-chip-option
            [value]="allocation"
            (click)="toggleSectionID(allocation, 'allocation')"
            [selected]="isSectionSelected(allocation)"
            [disabled]="isSectionSelected(allocation)">
            {{  allocation.translations[currentLanguage].title}}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>
    <div class="pb-4">
      <h4>Chart</h4>
      <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection">
        @for (chartOption of chartOptions; track chartOption; ) {
          <mat-chip-option [value]="chartOption.value"
                           [selected]="statistic.chart === chartOption.value"
                           [disabled]="statistic.chart === chartOption.value"
                           (click)="onChartSelectionChange(chartOption.value)">
            {{ chartOption.viewValue }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </div>

    @if(isPriceDataSelected()){
      <div class="pb-4">
        <h4>Intervall</h4>
        <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection">
          @for (frequencyOption of frequencyOptions; track frequencyOption) {
            <mat-chip-option [value]="frequencyOption.value"
                             [selected]="statistic.frequency === frequencyOption.value"
                             [disabled]="statistic.frequency === frequencyOption.value"
                             (click)="onFrequencySelectionChange(frequencyOption.value)">
              {{ frequencyOption.viewValue }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>

      <div>
        <h4>Statistics</h4>
        <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection" [multiple]="false">
          @for (statisticType of statisticOptions; track statisticType) {
            <mat-chip-option [value]="statisticType.value"
                             [selected]="isSelectedStatistic(statisticType.value)"
                             [disabled]="isSelectedStatistic(statisticType.value) && statistic.statistics.length === 1"
                             (click)="onStatisticSelectionChange(statisticType.value)">
              {{ statisticType.viewValue }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }

  </div>
}



